<template>
  <v-btn
    class="navbarButton final v-step-5"
    name="action"
    :disabled="!btnState"
    @click="exportFile"
  >
    <v-icon>file_copy</v-icon>
    Export
  </v-btn>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      btnState: 'btnExportValue',
    }),
  },
  methods: {
    exportFile() {
      if (this.btnState === true) {
        const exportFileUrl =
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_EXPORT_FILE;
        const user = this.$store.state.user;
        var self = this;
        self.btn = 'btn-disabled';
        self.$emit('loadSpinner');
        axios({
          method: 'get',
          url: exportFileUrl,
          timeout : 600000,
          headers: {
            'Content-Type': 'application/json',
            user: user,
          },
          responseType: 'blob',
        })
          .then(response => {
            self.disabled = false;
            self.btn = 'btn';
            var dt = new Date();
            self.$emit('hideSpinner');
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              'Optiflux_export_' +
                dt.getFullYear() +
                '/' +
                (dt.getMonth() + 1) +
                '/' +
                dt.getDate() +
                '.xlsm'
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            self.btn = 'btn';
            self.$emit('hideSpinner');
            this.$toasted.show(
              "Votre fichier n'a pas pu être traité, veuillez vous référer à l'email reçu pour en savoir plus.",
              { type: 'error' }
            );
          });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
